<div class="accordion">
  @if (accordionHeaderTemplate || title()) {
    <app-accordion-header
      [accordionHeaderTemplate]="accordionHeaderTemplate"
      [title]="title()"
    />
  }

  @if (panels()) {
    @for (panel of panels(); track $index) {
      <app-accordion-panel
        (toggle)="onToggle(castToAccordionEvent($event))"
        [accordionPanelContentTemplate]="accordionPanelContentTemplate"
        [accordionPanelHeaderTemplate]="accordionPanelHeaderTemplate"
        [hasBorder]="hasBorder()"
        [panel]="panel"
      />
    }
  }

  <ng-content select="app-accordion-panel" />
</div>
